import { type ReactElement } from 'react'
import { Link, useNavigate, createFileRoute } from '@tanstack/react-router'
import { useQueryDisclosure } from '@hooks'
import { useImports, useTranslation } from '@front/model'
import { ButtonAdd, ConditionTooltip } from '@components'
import { useImportPermission } from '../integration.import_.add/useImportPermission'
import { ImportsList } from './ImportsList'

function Import(): ReactElement {
  const { t } = useTranslation()
  const [showArchived, { toggle }] = useQueryDisclosure('showArchived')
  const imports = useImports({ archived: showArchived })
  const { data: permissions, isLoading: isLoadingPermissions } = useImportPermission()
  const navigate = useNavigate()

  return (
    <ImportsList
      imports={imports}
      showArchived={showArchived}
      addControl={
        <ConditionTooltip
          conditions={[
            {
              active: isLoadingPermissions,
              label: t('Checking permission'),
            },
            {
              active: Object.values(permissions).every((p) => !p),
              label: t('You do not have permission to import data'),
            },
          ]}
        >
          <ButtonAdd component={Link} to='/integration/import/add'>
            {t('Import Data')}
          </ButtonAdd>
        </ConditionTooltip>
      }
      onRowClick={(record) => navigate({ to: `/integration/import/${record.importId}` })}
      onToggleArchived={toggle}
    />
  )
}

export const Route = createFileRoute('/integration/import/')({
  component: Import,
})
